import React from 'react';
import { Box } from '@mui/material';

import { ListImage, } from '../../style/image'
import NoImg from '../../_img/img_no_image.png'

export default function ContentsImage(props) {

    return (
        <>
            <Box sx={{
                width: props.width,
                maxWidth: props.maxWidth,
            }}>
                <ListImage
                    src={props.imgSrc}      
                    srcSet={props.imgSrc}
                    loading="lazy"
                    onError={(e) => {
                        // 一度NoImgに切り替えたら再発防止
                        if (e.target.src.includes('img_no_image.png')) return;

                        // srcSetも空にすることで無限ループ防止
                        e.target.removeAttribute('srcset');
                        e.target.src = NoImg;
                    }}
                    onClick={() => props.handleClick(props.row)} />
            </Box>
        </>
    )
}
